var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UsernameLink',{attrs:{"wrapClass":'arti-top',"user-id":_vm.ownerId,"username":_vm.ownerNickName,"user-address":_vm.ownerAddress}})
}
var staticRenderFns = []

export { render, staticRenderFns }